<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ff4081" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="graph-page-container">
    <!-- Header Section -->
    <div class="header-card" #bucketsSection>
        <div class="header-content">
            <div class="title-container">
                <h2 class="graph-title">Graphs</h2>
            </div>
            <!-- Date Picker Section -->
            <ng-container *ngIf="userService.resourceRole?.toLowerCase() == 'admin'">
                <app-date-picker [fromDate]="fromDate" [toDate]="toDate"
                    (dateChange)="onDateChanges($event)"></app-date-picker>
            </ng-container>
        </div>
    </div>

    <div class="graph-page-charts">
        <!-- Chart Card -->
        <mat-card class="graph-page-chart-card">
            <mat-form-field appearance="outline" class="graph-page-form-field">
                <mat-label>Chart Type</mat-label>
                <mat-select (selectionChange)="changeSelectedType($event)" [(ngModel)]="selectedChartType"
                    class="graph-page-select">
                    <mat-option *ngFor="let type of chartType" [value]="type">
                        {{type}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="graph-page-chart-container">
                <canvas baseChart [datasets]="chartData" [labels]="displayedLabels" [options]="barChartOptions"
                    [legend]="true" [type]="selectedChartType"
                    (chartClick)="chartClicked($event, false, workordersSection)"></canvas>
            </div>
        </mat-card>

        <!-- Admin Workorder Chart Card -->
        <mat-card class="graph-page-chart-card" *ngIf="userService.resourceRole?.toLowerCase() == 'admin'">
            <div class="graph-page-form-group">
                <mat-form-field appearance="outline" class="graph-page-form-field">
                    <mat-label>Workorder Type</mat-label>
                    <mat-select (selectionChange)="changeWorkorderType($event)" [(ngModel)]="selectedWorkorderType"
                        class="graph-page-select">
                        <mat-option *ngFor="let workorder of dataMatrix" [value]="workorder.WorkorderType">
                            {{workorder.WorkorderType}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="graph-page-form-field">
                    <mat-label>Chart Type</mat-label>
                    <mat-select (selectionChange)="changeWoSelectedType($event)" [(ngModel)]="barChartType"
                        class="graph-page-select">
                        <mat-option *ngFor="let type of chartType" [value]="type">
                            {{type}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="graph-page-chart-container">
                <canvas baseChart [datasets]="barChartData" [labels]="displayedLabels" [options]="barChartOptions"
                    [legend]="true" [type]="barChartType"
                    (chartClick)="chartClicked($event, true, workordersSection)"></canvas>
            </div>
        </mat-card>

        <!-- Non-Admin Chart Card -->
        <mat-card class="graph-page-chart-card graph-page-chart-card-scrollable"
            *ngIf="userService.resourceRole?.toLowerCase() != 'admin'">
            <div class="graph-page-chart-container">
                <canvas baseChart [datasets]="barChartData" [labels]="displayedLabels" [options]="barChartOptions"
                    [type]="barChartType" (chartClick)="matrixChartClicked($event, workordersSection)"></canvas>
            </div>
        </mat-card>
    </div>

    <mat-card class="user-mat-card">
        <div class="user-card-header" #workordersSection>
            <h2 class="user-card-title">Workorders</h2>
            <span class="user-card-spacer"></span>
            <button mat-flat-button color="primary" (click)="refrehPage()">Reset
                Filter</button>
        </div>
        <mat-divider></mat-divider>
        <mat-card-content class="user-card-content">
            <table mat-table [dataSource]="dataSource" matSort class="user-card-table">
                <ng-container matColumnDef="WorkorderID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Workorder ID
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder ID
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="workorderIDFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('workorderIDFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row" class="user-card-cell">{{row.WorkorderID}}</td>
                </ng-container>

                <ng-container matColumnDef="WorkorderType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Workorder Type
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder Type
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="workorderTypeFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('workorderTypeFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell"
                        matTooltip="{{workorder.WorkorderType}}">
                        {{workorder.WorkorderType}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="AccountHolder">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Account Holder
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Account Holder
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="accountHolderFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('accountHolderFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell"
                        matTooltip="{{workorder.AccountHolder}}">
                        {{workorder.AccountHolder}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Distributor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Distributor Name
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Distributor
                                Name</div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="distributorFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('distributorFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell"
                        matTooltip="{{workorder.Distributor}}">
                        {{workorder.Distributor}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Contractor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Contractor Name
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Contractor Name
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="contractorFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('contractorFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell"
                        matTooltip="{{workorder.Contractor}}">
                        {{workorder.Contractor}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="WorkorderStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">
                        Workorder Status
                        <button mat-button class="btn-toggle" [matMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()" matRipple="false">
                            <mat-icon>filter_alt</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder
                                Status</div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <mat-form-field class="user-card-filter-field">
                                    <input matInput class="form-field" [formControl]="workorderStatusFilter"
                                        placeholder="Value">
                                </mat-form-field>
                            </div>
                            <div mat-menu-item mat-filter-item [disableRipple]="true">
                                <button mat-raised-button color="primary"
                                    (click)="clearColumn('workorderStatusFilter')">Clear</button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell"
                        matTooltip="{{workorder.WorkorderStatus}}">
                        {{workorder.WorkorderStatus}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Updated">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="user-card-header-cell">Updated Date
                    </th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell">
                        {{workorder.Updated | date:'shortDate'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Details">
                    <th mat-header-cell *matHeaderCellDef class="user-card-header-cell user-card-header-cell-details">
                        Details</th>
                    <td mat-cell *matCellDef="let workorder" class="user-card-cell">
                        <button mat-button class="user-card-details-button"
                            (click)="handleEnrollmentWorkorderClick(workorder, workorder.EnrollmentId)">
                            <mat-icon class="user-card-details-icon">label_important</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="user-card-header-row"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="user-card-row"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[100, 200, 300, 400, 500]" showFirstLastButtons
                class="user-card-paginator"></mat-paginator>
            <button mat-fab class="scroll-to-top"
                (click)="scrollToBuckets(bucketsSection)"><mat-icon>arrow_upward</mat-icon></button>
        </mat-card-content>
    </mat-card>
</div>